import React, {Fragment} from "react"
import { Table } from "semantic-ui-react"
import Price from "components/Price/Price";
import shop from "shop/shop"
import Responsive from "react-responsive"

const PositionRow = ( { position, product } ) => {
  const useProductData = product && product.extras
  //const reweNan = position.extras && position.extras.rewe_nan ? JSON.parse(position.extras.rewe_nan.value) : null;
  //console.log("reweNan", reweNan)
  return (
    <Fragment>
      <Responsive minWidth={790}>
        <tr>
          <td className="bb ProductRowDefReturn">{position.article_nr}&nbsp;{position.desc}</td>
          <td className="bb ProductRowDefReturn">{position.barcode}</td>
          <td className="bb ProductRowDefReturn">&nbsp;</td>
          {shop.session && shop.session.value && shop.session.value.extras && shop.session.value.extras.edeka_extra && shop.session.value.extras.edeka_extra == "Ja" &&
          <td className="tl bb ProductRowDefReturn">
            {position.extras && position.extras.edeka_nan && JSON.parse(position.extras.edeka_nan).value.value && <p style={{textAlign: "left"}}>{`${JSON.parse(position.extras.edeka_nan).value.value}`}</p>}
          </td>}
          <td className="tl bb ProductRowDefReturn">{position.count} {translate("Stück")} <br/>
          </td>
        </tr>
      </Responsive>
      <Responsive maxWidth={789}>
        <tr className={` ProductRowDefReturnMobile step `}>
          <td className="fw7 ">Artikel: </td>
          <td className="bb b--black-20 tr">{position.article_nr}&nbsp;<strong>{position.desc}</strong></td>
        </tr>
        <tr className={` ProductRowDefReturnMobile step `}>
          <td className="fw7 ">EAN: </td>
          <td className="bb b--black-20 tr"><strong>{position.barcode}</strong></td>
        </tr>
        {shop.session && shop.session.value && shop.session.value.extras && shop.session.value.extras.edeka_extra && shop.session.value.extras.edeka_extra == "Ja" &&  <tr className={` ProductRowDefReturnMobile step `}>
          <td className="fw7 ">EDEKA Art-Nr.: </td>
          <td className="bb b--black-20 tr"><strong>{position.extras && position.extras.edeka_nan && JSON.parse(position.extras.edeka_nan).value.value && <p className="tr">{JSON.parse(position.extras.edeka_nan).value.value}</p>}</strong></td>
        </tr>}
        <tr className={` ProductRowDefReturnMobile step`}>
          <td className="bb fw7 ProductRowDefReturnMobileLeft">{translate("Restanten:")}</td>
          <td className="tr b--black-20 bb ProductRowDefReturnMobileRight">{position.count}</td>
        </tr>
      </Responsive>
    </Fragment>
  )
}

const SuccessTable = ( { positions, netto, byId, append = null, prepend = null } ) => {
  const tax = Number( netto ) / 100 * Number( shop.config.taxRate )
  const hasTax = shop.config.taxRate
  return (
    <Fragment>
            <Responsive minWidth={790}>
        <Table className="TableCustData" >
      <colgroup>
          <col width="50%"/>
          <col width="15%"/>
          <col width="15%"/>
          <col width="15%"/>
          {shop.session && shop.session.value && shop.session.value.extras && shop.session.value.extras.edeka_extra && shop.session.value.extras.edeka_extra == "Ja" && <col width="15%"/>}
          {/*<col width="15%"/>*/}
      </colgroup>
      <Table.Header>
          <tr>
              <th className="tr">{translate( "Artikel" )}</th>
              <th className="tl">EAN</th>
              <th style={{alignContent:"right",textAlign:"right"}} className="tl">&nbsp;</th>
              {shop.session && shop.session.value && shop.session.value.extras && shop.session.value.extras.edeka_extra && shop.session.value.extras.edeka_extra == "Ja" &&
              <th style={{alignContent:"left",textAlign:"left"}} className="tr">EDEKA Art-Nr.</th>}
              
              <th style={{alignContent:"right",textAlign:"left"}} className="tr">{translate( "Restanten" )}</th>
              {/*<th style={{alignContent:"right",textAlign:"right"}} className="tr">{translate( "UVP" )}</th>*/}
          </tr>
      </Table.Header>
        <Table.Body>
          {prepend && prepend}
          
          {positions.map( ( position ) => {
            const product = byId[ position.article_id ]
            return <PositionRow key={position.article_id} position={position} product={product}/>
          } )}
          
          {/*<Table.Row>
            <Table.Cell colSpan={4} className=" tr">
              <div className="tr f3 fw7" style={{color:"#917236"}}>{translate( "UVP:" )}</div>
            </Table.Cell>
            <Table.Cell>
              <div className="pv3 f3 tr "><Price>{netto}</Price></div>
            </Table.Cell>
        </Table.Row>*/}
          
          {append && append}
          {hasTax && <Table.Row>
            <Table.Cell colSpan={4} className=" tr">
              <div className="tr"><span className="f5  ">{translate( "zzgl. Steuern" )} ({shop.config.taxRate.replace( ".", "," )}%)</span></div>
            </Table.Cell>
            <Table.Cell>
              <div className="pv3 f3 tr "><Price>{tax}</Price></div>
            </Table.Cell>
          </Table.Row>}
          
          {hasTax && <Table.Row>
            <Table.Cell colSpan={4} className=" tr">
              <div className="tr"><span className="f5 b black">{translate( "inkl. Steuern" )}</span></div>
            </Table.Cell>
            <Table.Cell>
              <div className="pv3 f3 tr "><Price>{tax + Number( netto )}</Price></div>
            </Table.Cell>
          </Table.Row>}
        
        </Table.Body>
      </Table>
      </Responsive>
      <Responsive maxWidth={789}>
          <table className="TableCustData" >
            <colgroup>
              <col width="30%"/>
              <col width="70%"/>
              </colgroup>
            <tbody>
            {positions.map( ( position ) => {
            const product = byId[ position.article_id ]
            return <PositionRow key={position.article_id} position={position} product={product}/>
          } )}
          {/*<tr>
            <td className="bb fw7 f4 ProductRowDefReturn">{translate( "UVP:" )}</td>
            <td className="tr bb fw7 f4 ProductRowDefReturn"><Price>{netto}</Price></td>
        </tr>*/}
            </tbody>
          </table>
      </Responsive>
    </Fragment>
  )
}

export default SuccessTable


// WEBPACK FOOTER //
// ./src/theme/lindt/components/Product/SuccessTableReturn.js